import React, { useEffect, useMemo } from 'react';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from 'store/actions';
import CustomAutocomplete from '../../../../views/HomeScreen/CustomAutocomplete';
import { Grid2 } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: theme.fonts.base,
    fontSize: 25
  },
  reset: {
    marginLeft: theme.spacing(3),
    color: '#5381EF',
    fontFamily: theme.fonts.base,
    cursor: 'pointer'
  },
  closeIcon: {
    cursor: 'pointer',
    color: '#5C5C5C'
  }
}));

const SideFilters = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { data: managers } = useSelector((state) => state.assets.assetManagers);
  const { managers: selectedManagers } = useSelector((state) => state.alerts.sidebarFilters);

  const managerOptions = useMemo(
    () => managers.map(it => ({ ...it, id: it.manager, name: it.manager })),
    [managers]
  );

  useEffect(() => {
    dispatch(actions.getAssetManagers());
  }, []);

  const updateSelectedManagers = (selectedManagers) => {
    let assetIds = managers.reduce((acc, item) => {
      if (selectedManagers.includes(item.manager)) {
        acc = [...acc, ...item.assetidsList];
      }

      return acc;
    }, []);

    if (assetIds.length === 0) {
      assetIds = null;
    }

    dispatch(actions.updateAlertSidebarFilters(selectedManagers, assetIds));
  };

  return (
    <Box display="flex" flexDirection="column" style={{ width: '100%' }}>
      <Box display="flex" justifyContent="space-between" p={2} alignItems="center">
        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography className={classes.title}>Alerts</Typography>
        </Box>

        <CloseIcon
          className={classes.closeIcon}
          onClick={() => dispatch(actions.toggleAlertMenu())}
        />
      </Box>

      <Grid2 item style={{ width: '100%' }}>
        <CustomAutocomplete
          items={managerOptions}
          updateUrlParams={updateSelectedManagers}
          label="Asset Managers"
          placeholder="Asset Managers"
          urlParams={selectedManagers}
        />
      </Grid2>
    </Box>
  );
};

export default SideFilters;
